import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import Footer from "../components/Footer";

const PrivacyPolicyPage = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-gray-100 py-6 px-6">
        <div className="max-w-6xl mx-auto flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_centered-nav/artifacts/o3oyffod_0AB76696-D43D-4560-996B-0C817906B442.PNG" 
              alt="takeatrip NYC" 
              className="h-16 w-auto"
            />
          </Link>

          {/* Title */}
          <h1 className="text-3xl font-bold text-slate-800 text-center flex-1">
            Privacy Policy
          </h1>

          {/* Events Banner */}
          <Link to="/events">
            <Button 
              className="px-6 py-3 text-lg font-semibold rounded-full"
              style={{
                background: 'linear-gradient(to right, #1d476a, rgb(51 65 85))',
                color: 'white',
                border: 'none'
              }}
            >
              Events
            </Button>
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto py-12 px-6">
        <div className="prose prose-slate max-w-none">
          <div className="text-slate-700 leading-relaxed space-y-6">
            
            <p><strong>Effective Date:</strong> October 1, 2025</p>
            
            <p>takeatrip NYC is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and protect your information when you visit our website or use our services.</p>

            <h2 className="text-xl font-bold text-slate-800 mt-8 mb-4">Information We Collect</h2>
            <p>Name, email, phone number, payment and billing information, travel preferences and booking details, IP address and browser data (via cookies).</p>

            <h2 className="text-xl font-bold text-slate-800 mt-8 mb-4">How We Use Your Information</h2>
            <p>To process bookings and payments, to communicate about your trip, to send promotional emails (opt-out anytime), and to improve our website and services.</p>

            <h2 className="text-xl font-bold text-slate-800 mt-8 mb-4">Sharing Information</h2>
            <p>We do not sell your personal information. We may share your data with trusted service providers (e.g., payment processors, travel partners) and legal authorities only if required by law.</p>

            <h2 className="text-xl font-bold text-slate-800 mt-8 mb-4">Cookies</h2>
            <p>We use cookies to enhance your browsing experience. You can control cookie settings in your browser at any time.</p>

            <h2 className="text-xl font-bold text-slate-800 mt-8 mb-4">Data Security</h2>
            <p>We use third-party platforms and services, such as Stripe for payment processing, which include their own security protocols. We do not store sensitive payment information on our systems. While we rely on these services to protect your data, no online system is completely secure, and we cannot guarantee absolute protection of your information.</p>

            <h2 className="text-xl font-bold text-slate-800 mt-8 mb-4">Photo & Video Use</h2>
            <p>By participating in a takeatrip NYC trip, you acknowledge that photos and videos may be taken during the experience. These may be used by takeatrip NYC for marketing purposes (e.g., social media, website, email promotions) and promotional materials or advertising. If you do not wish to appear in any photos or videos, please notify us in writing before the trip at <a href="mailto:info@takeatripnyc.com" className="text-blue-600 hover:text-blue-800">info@takeatripnyc.com</a>, and we will make reasonable efforts to accommodate your request.</p>

            <h2 className="text-xl font-bold text-slate-800 mt-8 mb-4">Your Rights</h2>
            <p>You may request to access, correct, or delete your personal data at any time by contacting us at: <a href="mailto:info@takeatripnyc.com" className="text-blue-600 hover:text-blue-800">info@takeatripnyc.com</a>.</p>

          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default PrivacyPolicyPage;